import { useEffect, useState } from 'react';
import type { GuestView } from '@london-life/contracts';
import { PersonPicture } from '../people/person-card';

const nameOf = (person: { username: string | null; firstName: string }) =>
  person.username ? `@${person.username}` : person.firstName;

// Someone at your door (Lagos Life's knock): over whatever screen is open, with a buzz on a phone. Let them in,
// or not now. One knock at a time; the next shows when this one is answered.
export function KnockAlert({
  guests,
  busy,
  onAnswer,
}: {
  guests: GuestView[];
  busy: boolean;
  onAnswer: (visitId: string, letIn: boolean) => void;
}) {
  const [now, setNow] = useState(() => Date.now());
  const waiting = guests.filter((guest) => guest.status === 'knocking');
  // still on the way: look again when they should be at the door
  useEffect(() => {
    if (!waiting.length) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [waiting.length]);
  const knock = waiting.find((guest) => new Date(guest.arrivesAt).getTime() <= now);
  const knockId = knock?.visitId;
  useEffect(() => {
    if (knockId) navigator.vibrate?.([60, 80, 60]);
  }, [knockId]);
  if (!knock) return null;
  const name = nameOf(knock);
  return (
    <div className="knock-alert" role="alertdialog" aria-label={`${name} is knocking`}>
      <PersonPicture person={knock} />
      <div className="knock-alert-text">
        <strong>{name} is knocking</strong>
        <small>🚪 At your door now</small>
      </div>
      <div className="knock-alert-actions">
        <button type="button" className="knock-no" disabled={busy} onClick={() => onAnswer(knock.visitId, false)}>
          Not now
        </button>
        <button type="button" className="knock-yes" disabled={busy} onClick={() => onAnswer(knock.visitId, true)}>
          Let in
        </button>
      </div>
    </div>
  );
}
